import { render, staticRenderFns } from "./CstmrRegByCstmrExpired.vue?vue&type=template&id=201cc61a&"
import script from "./CstmrRegByCstmrExpired.vue?vue&type=script&lang=js&"
export * from "./CstmrRegByCstmrExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports